import PropTypes from 'prop-types';

const filterPropTypes = {
  assetClasses: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
  })).isRequired,
  dropdownClassName: PropTypes.string.isRequired,
  dropdownLabel: PropTypes.string.isRequired,
  showOptions: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  applyFilter: PropTypes.func.isRequired,
  clearFilter: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  filterCount: PropTypes.number.isRequired,
};

export default filterPropTypes;
